<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">User Preferences</h1>
  </div>
  <div>
    <button mat-flat-button color="primary" id="save-button" class="action-button"
            (click)="onSave()">
      Save
    </button>
  </div>
</div>
<div id="main-content" class="d-flex gap-16 align-content-between">
  <h3>Primary FCORG:</h3>
  <mat-form-field class="default-margin" subscriptSizing="dynamic">
<!--    <mat-label>Primary FCORG</mat-label>-->
    <mat-select [(ngModel)]="primaryFcorg" id="primaryFcorg">
      <mat-option [value]="undefined"></mat-option>
      <mat-option *ngFor="let fcorg of fcorgOptions" [value]="fcorg">{{ fcorg }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
